import styled from "styled-components";

const SubFooterWrapper = styled.div`
  .next-wrapper {
    // padding-bottom: 7rem !important;
    width: 100%;
    padding: 0.5rem 0 !important;
    background: rgba(129, 139, 155, 0.1);
    padding-bottom: 2.5rem;
    // position: absolute;
    // bottom: 57px;

    .p-accordion-header {
      display: none;
    }

    .p-accordion .p-accordion-content {
      background: transparent;
      border: 0;
      // padding: 1.25rem 0
    }

    .price-button-wrapper {
      display: flex;
      justify-content: space-between;

      p {
        margin: 0;
      }

      .total-price {
        display: flex;
        align-items: center;
      }

      .des {
        margin-left: 16px;
        margin-right: 40px;

        .des_vat {
          font-size: 12px;
          margin-top: -5px;
          text-align: left;
        }

        .des_vat_color {
          font-size: 18px;
          font-weight: bold;
          color: #6b47f5;
        }
        .des_vat_color-stc {
          font-size: 18px;
          font-weight: bold;
          color: #4f008c;
        }

        button {
          font-size: 13px;
          text-decoration: underline;
          color: #6b47f5;
          cursor: pointer;

          &:focus {
            box-shadow: none !important;
          }
        }
      }

      .price {
        font-size: 20px;
        color: #6b47f5;

        span {
          font-size: 20px;
          color: #818b9b;
        }
      }
    }

    .btn-wrapper {
      display: flex;
      margin-left: auto;
      margin-right: 0;
      gap: 16px;
    }

    .secondary_outline {
      font-weight: bold;
      color: #6b47f5;
      border: solid 1px #6b47f5;
      background-color: #fff;
      border-radius: 0;
      height: 50px;

      display: flex;
      align-items: center;

      img {
        margin: 0 5px;
        height: 24px;
      }
    }
    .secondary_outline-stc {
      color: #4f008c;
    }

    .primary {
      display: flex;
      align-items: center;
      height: 50px;
      width: auto;
      color: #ffffff;
      background: #6b47f5;
      border: 1px solid #6b47f5;
      border-radius: 0;
      padding: 8px 15px;
      font-weight: 700;
      .p-button-icon {
        margin-right: 10px;
      }
      img {
        margin: 0 5px;
      }
      &:focus {
        box-shadow: none;
      }
    }

    .price_description {
      display: flex;
      flex-direction: column;

      .cell {
        font-size: 13px;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #818b9b;
        padding-bottom: 0.5rem;
      }
    }
    .discount_price{
      display: flex;
      flex-direction: column;
      text-align: start;
      .price_block{
        display: flex;
        gap: 1rem
      }
      .total_before{
        display: inline-block;
        color: var(--neutral-silver, #B3B9C3);
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: 130%; /* 1.95rem */
        letter-spacing: -0.045rem;
        text-decoration-line: line-through;
        .sar{
          display: inline-block;
          color: var(--neutral-silver, #B3B9C3);
          font-size: 0.75rem;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
          letter-spacing: -0.0225rem;
          text-decoration-line: line-through;         
        }
      }
      .total_after{
        display: inline-block;
        color: var(--primary-primary-color, #6B47F5);
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 1.95rem */
        letter-spacing: -0.045rem;
        .sar{
          color: var(--primary-primary-color, #6B47F5);
          font-size: 0.75rem;
          font-style: normal;
          font-weight: 700;
          line-height: 0.75rem;          
        }
      }
      .enjoy{
        color: var(--success-success, #5DB364);
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 1.625rem */
        letter-spacing: -0.0375rem;        
      }
    }

    &.ar {
      .btn-wrapper {
        margin-right: auto;
        margin-left: 0;
      }

      .primary {
        img {
          transform: rotate(180deg);
        }
      }

      .price-button-wrapper .des {
        margin-left: 40px;
        margin-right: 16px;
      }

      .price {
        direction: ltr;
      }
    }
  }
  .worldcup_payment_bg_img_footer {
    padding-top: 20px;
    padding-bottom: 4.2rem !important;
  }

  @media only screen and (max-width: 576px) {
    padding-bottom: 0 !important;

    .price-button-wrapper {
      flex-direction: column;
      align-items: center;

      .primary {
        margin: 0;
      }
    }

    .total-price {
      width: 100%;
      flex-direction: column;
      align-items: center;
      margin-bottom: 1rem;

      .des {
        margin: 0 !important;
      }
    }
    .next-wrapper {
      .price-button-wrapper {
        .des {
          .des_vat {
            text-align: center;
          }
        }
      }
    }

    .btn-wrapper {
      margin: 0 !important;
    }
  }
`;

export default SubFooterWrapper;
